import $ from 'jquery';
import throttle from 'lodash/throttle';

const headerElement = document.querySelector('header.header');
const $headerElement = $(headerElement);
const headerHeight = $headerElement.height();
const hamburgerButton = headerElement.querySelector('a.hamburger');
const mobileNavElement = document.querySelector('.mobile-nav');

function checkHeaderScroll() {

	if (window.scrollY > 30) {
		return $headerElement.addClass('is-scrolled')
	}

	return $headerElement.removeClass('is-scrolled')
}


export default function nav() {

	$(window).on('resize load', throttle(function () {
		if (window.innerWidth < 980) {
			$(window).on('load scroll.headerscroll', throttle(checkHeaderScroll, 100));
		} else {
			$(window).off('scroll.headerscroll');
		}
	}, 500));

	// Handle clicks on the hamburger button
	hamburgerButton.addEventListener('click', function () {
		hamburgerButton.classList.toggle('is-active');
		mobileNavElement.classList.toggle('is-open');
		headerElement.classList.toggle('nav-is-open');
	});

	let showChildrenLinks = document.querySelectorAll('.mobile-show-children');
	let childrenNavs = document.querySelectorAll('.mobile-nav__child');

	[...showChildrenLinks].forEach((v, i, a) => {
		let parentID = v.dataset.parentId;
		v.addEventListener('click', (e) => {
			e.preventDefault();
			let childContainer = document.getElementById('children-' + parentID);
			childContainer.style.left = 0;
			return false;
		});
	});

	[...childrenNavs].forEach((v, i, a) => {
		let back = v.querySelector('.back');
		back.addEventListener('click', (e) => {
			e.preventDefault();
			v.style.left = '100%';
		});

		let childToggles = v.querySelectorAll('.toggleChild');

		if (childToggles) {
			[...childToggles].forEach((value, index, array) => {
				value.addEventListener('click', (ev) => {
					let childID = value.dataset.childId;
					let childContainer = document.getElementById('child-' + childID);

					if (childContainer.style.maxHeight) {
						childContainer.style.maxHeight = null;
						childContainer.classList.remove('expanded');
					} else {
						childContainer.classList.add('expanded');
						childContainer.style.maxHeight = childContainer.scrollHeight + "px";
					}
				});
			});
		}

	});
}